import { render } from "./HeroiconsOutlineQrcode.vue?vue&type=template&id=2eb45d34"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineQrcode.vue"]])

export default __exports__